(() => {
  if (window.Shopify?.designMode || document.documentElement.dataset.sfGuideTracking !== 'live') return;
  const measurementId = 'G-8NVESWZFNZ';
  const permitted = () => window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true;
  let ready = false;
  function prepare() {
    if (!permitted() || ready) return false;
    ready = true;
    if (typeof window.gtag !== 'function') {
      window.dataLayer = window.dataLayer || [];
      window.gtag = function () { window.dataLayer.push(arguments); };
      window.gtag('js', new Date());
    }
    window.gtag('config', measurementId, {send_page_view: false});
    if (!document.querySelector('script[src*="googletagmanager.com/gtag/js"]')) {
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://www.googletagmanager.com/gtag/js?id=' + measurementId;
      document.head.appendChild(script);
    }
    return true;
  }
  if (window.Shopify?.customerPrivacy) {
    prepare();
  } else if (typeof window.Shopify?.loadFeatures === 'function') {
    window.Shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.1'}], (error) => {
      if (!error) prepare();
    });
  }
  document.addEventListener('visitorConsentCollected', prepare);
  document.addEventListener('click', (event) => {
    const link = event.target.closest?.('#MainContent a[href]');
    if (!link || event.defaultPrevented || !permitted()) return;
    const destination = new URL(link.href, window.location.origin);
    if (destination.origin !== window.location.origin) return;
    const shoppingPath = /^\/(products|collections)\//.test(destination.pathname) || /^\/pages\/(body-wash|hand-wash|body-care|incense-cones|perfume|room-sprays|reed-diffusers|luxury-body-cream|gift-sets|luxury-scented-candles)\/?$/.test(destination.pathname);
    if (!shoppingPath) return;
    prepare();
    const sameTab = !event.ctrlKey && !event.metaKey && !event.shiftKey && !event.altKey && event.button === 0 && (!link.target || link.target === '_self');
    let navigated = false;
    const continueNavigation = () => {
      if (!sameTab || navigated) return;
      navigated = true;
      window.location.assign(destination.href);
    };
    if (sameTab) {
      event.preventDefault();
      window.setTimeout(continueNavigation, 650);
    }
    window.gtag('event', 'guide_shop_click', {
      send_to: measurementId,
      guide_path: window.location.pathname,
      shop_path: destination.pathname,
      link_text: link.textContent.trim().replace(/\s+/g, ' ').slice(0, 100),
      event_callback: continueNavigation,
      event_timeout: 600
    });
  });
})();
